import {Theme} from "../../stem-core/src/ui/style/Theme.js";

// Theme to be used inside the wallet portion of the widget
export const WidgetWalletTheme = Theme.Global.fork("WidgetWallet", {
    MERCHANT_ERROR: "#FF8800", // Needs to be readable on green
    BUTTON_PRIMARY_BACKGROUND: props => props.WALLET,
    BUTTON_PRIMARY_DISABLED_COLOR: props => props.WALLET_2,
    BUTTON_PRIMARY_HOVER_BACKGROUND: props => props.WALLET_10,

    TOGGLE_BACKGROUND: props => props.WALLET_17,
    TOGGLE_DISABLED_BACKGROUND: props => props.WALLET_7,
    TOGGLE_SHADOW: "0 1px 1px rgba(0,0,0,.14), 0 2px 1px  -1px rgba(0,0,0,.12), 0 1px 3px rgba(0,0,0,.2)",
    TOGGLE_COLOR: props => props.WALLET_2,

    BASE_INPUT_BACKGROUND: props => props.WALLET_15,
    BASE_INPUT_PLACEHOLDER_COLOR: props => props.WALLET_8,
    INPUT_TEXT_COLOR: props => props.WALLET_2,
});

export const WidgetMerchantTheme = Theme.Global.fork("WidgetMerchant", {
    BUTTON_PRIMARY_BACKGROUND: "#000000",
    BUTTON_PRIMARY_HOVER_BACKGROUND: "#000000",
    BUTTON_PRIMARY_DISABLED_BACKGROUND: "#000000",
    BUTTON_PRIMARY_SHADOW: "none",
    BUTTON_PRIMARY_TEXT_SHADOW: "none",
    BUTTON_PRIMARY_DISABLED_COLOR: props => props.WALLET_2,
});
